import * as React from 'react'
import {createStyles, Theme, WithStyles, withStyles, Paper, Grid, Icon, Divider} from '@material-ui/core'
import {compose} from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import Grow from '@material-ui/core/Grow/Grow'
import ProfileEditionForm from 'src/page/Consumer/Profile/ProfileEditionForm'
import autobind from 'autobind-decorator'
import { submit, isValid } from 'redux-form'
import Tooltip from '@material-ui/core/Tooltip/Tooltip'
import * as moment from 'moment'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { WithToast, withToast } from 'src/shared/Toast/Toast'
import Page from 'src/shared/Page/Page'
import Btn from 'src/shared/Btn/Btn'
import FormActions from 'src/shared/form/FormActions'
import { updateAccountInfos } from 'src/core/redux/action/accountInfosAction'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'
import { withRouter, RouteComponentProps } from 'react-router'
import { css } from 'src/conf/style'

const styles = (t: Theme) => createStyles({
  profileWpr: {
    padding: '2rem'
  },
  profileLblWpr: {
    display: 'flex',
    alignItems: 'center'
  },
  profileLbl: {
    paddingLeft: '8px',
    fontSize: '0.75rem',
    fontStyle: 'italic'
  },
  profileInfo: {
    paddingLeft: '32px'
  },
  profileName: {
    margin: '0 0 1rem 0',
    fontSize: '3rem',
    lineHeight: '3.5rem'
  },
  editButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  tooltip: {
    fontSize: 11
  },
  actionBack: {
    ...css.flexFullCenter,
    marginTop: '25px'
  }
});

interface IState {
  showEdition: boolean;
}


interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  RouteComponentProps<any>,
  WithToast,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
}

class Profile extends React.Component<IProps, IState> {

  state = {
    showEdition: false
  };

  render(){
    const { t, classes, connectedUser, isUpdating, valid } = this.props;
    const { showEdition } = this.state;
    return(
      <>
        <HelmetMeta title={t.App_title_page_Profile}/>
        <div>
          <Page withHead>
            {!showEdition &&
              <Grow in={!showEdition}>
                <Paper>
                  {connectedUser &&
                  <Grid container className={classes.profileWpr}>
                    <Grid item xs={12}>
                      <div className={classes.editButtonContainer}>
                        {connectedUser.edition_authorized &&
                        <Btn color='primary' onClick={this.toggleEdit} icon='lock_open'>
                          {t.edit}
                        </Btn>
                        }
                        {!connectedUser.edition_authorized &&
                          <Tooltip classes={{ tooltip: classes.tooltip }} title={t.Profile_cannot_edit_message}>
                            <Btn color='primary' onClick={this.toggleEdit} icon='lock' disabled>
                              {t.edit}
                            </Btn>
                          </Tooltip>
                        }
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <p className={classes.profileName}>{connectedUser!.first_name} {connectedUser!.last_name}</p>
                    </Grid>
                    <Grid item xs={12}>
                      <div className={classes.profileLblWpr}>
                        <Icon>email</Icon>
                        <label style={{fontStyle: 'italic', paddingLeft: '5px'}}>{connectedUser.email}</label>
                      </div>
                    </Grid>
                    <Divider style={{margin: '2rem auto 3rem', display: 'block', width: '90%'}}/>
                    {this.extInfos()}
                    <Grid item xs={12}>
                      <div className={classes.profileLblWpr}>
                        <Icon>card_travel</Icon>
                        <label  className={classes.profileLbl}>{t.job}</label>
                      </div>
                      <p className={classes.profileInfo}>{connectedUser!.job}</p>
                    </Grid>
                  </Grid>
                  }
                </Paper>
              </Grow>
            }

            {showEdition &&
              <Grow in={showEdition}>
                <Paper>
                  <Grid container className={classes.profileWpr}>
                    <Grid item xs={12}>
                        <h3>Edition des informations du profil</h3>
                        <ProfileEditionForm
                          onSubmit={this.submitForm}
                          initialValues={connectedUser}
                        />

                      <div style={{marginTop: 16}}>
                        <FormActions
                          cancelHandler={this.toggleEdit}
                          confirmHandler={this.props.submitFormRemotely}
                          loading={isUpdating}
                          disableConfirm={!valid}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Paper>
              </Grow>
            }
            
            <div className={classes.actionBack}>
              <Btn
                  color='primary'
                  variant='contained'
                  icon='keyboard_backspace'
                  onClick={this.back}
              >
                  {t.back}
              </Btn>
            </div>
          </Page>
        </div>
      </>
    )
  }

  @autobind
  private extInfos(){
    const {t, classes, connectedUser, formatDate} = this.props;
    const {phone = '-', main_phone = '-', birthday, address} = connectedUser
    return [
      {label: t.phone,                   icon: 'smartphone', value: phone},
      {label: t.main_phone,              icon: 'call', value: main_phone},
      {label: t.birthday,                icon: 'calendar_today', value: birthday ? formatDate(new Date(birthday)) : '-'},
      {label: t.Edit_profile_birthplace, icon: 'place', value: (address && address.city) ? <>{address.zip} {address.city}</> : t.not_available},
    ].map(i => (
      <Grid item md={6} xs={12}>
        <div className={classes.profileLblWpr}>
          <Icon>{i.icon}</Icon>
          <label className={classes.profileLbl}>{i.label}</label>
        </div>
        <p className={classes.profileInfo}>{i.value}</p>
      </Grid>
    ))
  }

  @autobind
  private back(){
    this.props.history.goBack();
  }

  @autobind
  private toggleEdit(){
    this.setState({showEdition: !this.state.showEdition});
  }

  @autobind
  private submitForm(values){
    if(values.birthday) values.birthday = moment(values.birthday).toISOString();
    this.props.updateUser(values)
      .then(() => {
        this.props.toastSuccess(this.props.t.Profile_edit_success_message)
        this.toggleEdit();
      });
  }

}


const state2props = (state: RootState) => ({
  connectedUser: state.accountInfo.connectedUser,
  isUpdating: state.accountInfo.isUpdating,
  valid: isValid('editProfileForm')(state)
});

const dispatch2props = dispatch => ({
  submitFormRemotely: () => dispatch(submit('editProfileForm')),
  updateUser: (data) => dispatch(updateAccountInfos(data)),
});

export default compose(
  withI18n,
  withToast,
  withRouter,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(Profile)



// WEBPACK FOOTER //
// ./src/page/Consumer/Profile/Profile.tsx